const module_name = "CommonData";
const $inject = [];

class CommonData {
  constructor() {
    this.STATES = {
      "NSW": "New South Wales",
      "VIC": "Victoria",
      "QLD": "Queensland",
      "WA": "Western Australia",
      "SA": "South Australia",
      "TAS": "Tasmania",
      "ACT": "Australian Capital Territory",
      "NT": "Northern Territory",
    };
    this.TITLES = [
      "Mr",
      "Ms",
      "Mrs",
      "Miss",
      "Dr",
      "Sir",
      "Prof",
    ];
    this.REFERRAL_STRUCTURE = {
      id: true,
      patientTitle: true,
      patientFirstname: true,
      patientMiddlename: true,
      patientLastname: true,
      patientStreetAddress: true,
      patientCity: true,
      patientState: true,
      patientPostcode: true,
      patientDob: true,
      patientPhone: true,
      patientPhoneBusiness: true,
      patientMedicare: true,
      senderTitle: true,
      senderFirstname: true,
      senderMiddlename: true,
      senderLastname: true,
      senderIdentifiers: true,
    };
    this.REPORT_STRUCTURE = {
      id: true,
      reasonForReferral: true,
      patientCompliance: true,
      patientMedicineKnowledge: true,
      dose_administration_aid: {
        has_daa: true,
        daa_type: true,
        has_more_daa_info_benefit: true,
      },
      patientConcerns: true,
      otherConcern: true,
      hmrReportMedications: true,
      hmrReportIssues: true,
      patientSignedPrivacyDocument: true,
      dateConducted: true,
    };

    function freeze(obj) {
      Object.freeze(obj);
      if (typeof obj === "object") {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            freeze(obj[key]);
          }
        }
      }
    }

    freeze(this);
  }
}

CommonData.$inject = $inject;

//noinspection JSValidateTypes
export default angular.module(module_name, [])
  .service("CommonData", CommonData)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/common-data.service.js
 **/